/**
 * Blog Article Section Fade-in Animation
 * セクションごとにふわっと表示されるアニメーション
 */
(function() {
  'use strict';

  // アニメーション対象のセレクタ
  const ANIMATION_SELECTORS = [
    '.content-section',
    '.blog-article .article-content > *'
  ];

  // Intersection Observer のオプション
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };

  // 要素が表示されたときのコールバック
  function handleIntersection(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }

  // アニメーションの初期化
  function initFadeInAnimation() {
    // prefers-reduced-motion をチェック
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // アニメーション無効の場合は全て表示
      ANIMATION_SELECTORS.forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(el) {
          el.classList.add('is-visible');
        });
      });
      return;
    }

    // Intersection Observer を作成
    var observer = new IntersectionObserver(handleIntersection, observerOptions);

    // 各セレクタの要素を監視
    ANIMATION_SELECTORS.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        observer.observe(el);
      });
    });
  }

  // DOMContentLoaded で初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeInAnimation);
  } else {
    initFadeInAnimation();
  }

  // Shopify テーマエディタ対応
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      initFadeInAnimation();
    });
  }
})();

